/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, June 2023
 * @flow
 */

import React from 'react';
import { Box, Button } from '@material-ui/core';
import useStyles from './useStyles';

const Footer = ({ onClose, onOk, cancelText, okText }) => {
  const classes = useStyles();
  return (
    <Box display={'flex'} alignItems={'center'} justifyContent={'flex-end'} mt={1}>
      <Button variant='outlined' size='small' className={classes.secondaryButton} onClick={onClose}>
        {cancelText}
      </Button>
      <Button variant='contained' size='small' className={classes.primaryButton} onClick={onOk}>
        {okText}
      </Button>
    </Box>
  );
};

export default Footer;
